/* BANGA: buy 2, get 1 free popup. window.BangaOffer.open() is also used by the two order forms. */
(function () {
  var dataEl = document.getElementById('BangaOfferData');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var catalog = data.catalog || [];
  var SEEN_KEY = 'banga-offer-seen';
  var TEXT = {
    title: '🎁 اشري زوز hoodies، والثالث بلاش!',
    second: 'Hoodie الثاني',
    free: '🎁 البلاش',
    needTwo: 'زيد hoodie ثاني، واختار الثالث بلاش: أي موديل، أي لون، أي مقاس.',
    needOne: 'عندك hoodie بلاش! اختارو توّة: أي موديل، أي لون، أي مقاس.',
    yesTwo: 'زيد الثاني والبلاش',
    yesOne: 'زيد البلاش',
    skipOne: 'لا، نكمّل هكّا',
    skipOnly: 'لا، نحب hoodie واحد برك',
    landing: 'تختار أي موديل، أي لون، أي مقاس. والخلاص عند الاستلام.',
    browse: 'شوف الموديلات',
    later: 'موش توّة',
    total: 'تخلّص',
    noDelivery: 'من غير التوصيل، وهو بلاش من 130 TND وفوق.',
    error: 'الموديل هاذا موش متوفّر توّة، اختار موديل آخر.',
  };

  function money(cents) {
    return Math.round(cents / 100) + ' TND';
  }
  // Same rule as snippets/banga-bundle and backend/Cart.gs
  function offerTotal(prices) {
    var free = Math.floor(prices.length / 3);
    return prices.slice().sort(function (a, b) { return b - a; }).slice(free).reduce(function (s, p) { return s + p; }, 0);
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function productOf(id) {
    return catalog.find(function (p) { return String(p.id) === String(id); });
  }
  function firstAvailable(product) {
    return product.variants.find(function (v) { return v.available; }) || product.variants[0];
  }

  var dialog = null;
  function closeDialog() {
    if (dialog) {
      if (dialog.open) dialog.close();
      dialog.remove();
      dialog = null;
    }
  }

  /* options: needed (0, 1 or 2), basePrices (cents of what is already chosen), defaultProductId, onAccept(picks), onSkip, skipLabel,
     text, yesLabel, onYes (for needed 0). picks = [{ variantId, productId }] */
  function open(options) {
    closeDialog();
    dialog = el('dialog', 'bop');
    dialog.setAttribute('aria-label', TEXT.title);
    var top = el('div', 'bop__top', TEXT.title);
    var close = el('button', 'bop__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'سكّر');
    close.addEventListener('click', closeDialog);
    top.appendChild(close);
    dialog.appendChild(top);
    var body = el('div', 'bop__body');
    dialog.appendChild(body);
    var needed = options.needed || 0;
    body.appendChild(el('p', 'bop__text', options.text || (needed === 2 ? TEXT.needTwo : needed === 1 ? TEXT.needOne : TEXT.landing)));

    var rows = [];
    var priceRow = el('div', 'bop__price');

    function refresh() {
      if (!needed) return;
      var prices = (options.basePrices || []).slice();
      rows.forEach(function (r) { prices.push(r.variant().price); });
      var full = prices.reduce(function (s, p) { return s + p; }, 0);
      priceRow.innerHTML = '';
      priceRow.appendChild(el('span', '', TEXT.total));
      var amounts = el('span');
      amounts.dir = 'ltr';
      amounts.appendChild(el('b', '', money(offerTotal(prices))));
      amounts.appendChild(el('s', '', money(full)));
      priceRow.appendChild(amounts);
      priceRow.appendChild(el('small', '', TEXT.noDelivery));
    }

    for (var i = 0; i < needed; i++) {
      (function (index) {
        var isFree = index === needed - 1;
        var row = el('div', 'bop__row' + (isFree ? ' bop__row--free' : ''));
        var img = el('img');
        img.alt = '';
        var name = el('div', 'bop__name', isFree ? TEXT.free : TEXT.second);
        var model = el('select');
        model.setAttribute('aria-label', 'الموديل');
        var size = el('select');
        size.setAttribute('aria-label', 'اللون والمقاس');
        catalog.forEach(function (p) {
          var o = el('option', '', p.title);
          o.value = p.id;
          model.appendChild(o);
        });
        if (options.defaultProductId && productOf(options.defaultProductId)) model.value = String(options.defaultProductId);
        var record = {
          model: model,
          variant: function () {
            return productOf(model.value).variants.find(function (v) { return String(v.id) === size.value; }) || firstAvailable(productOf(model.value));
          },
        };
        function fillSizes() {
          var product = productOf(model.value);
          var keep = firstAvailable(product).id;
          size.innerHTML = '';
          product.variants.forEach(function (v) {
            var o = el('option', '', v.title);
            o.value = v.id;
            o.disabled = !v.available;
            size.appendChild(o);
          });
          size.value = String(keep);
          showPicture();
        }
        function showPicture() {
          var v = record.variant();
          if (v.image) img.src = v.image;
          refresh();
        }
        rows.push(record);
        model.addEventListener('change', fillSizes);
        size.addEventListener('change', showPicture);
        row.appendChild(img);
        row.appendChild(name);
        row.appendChild(model);
        row.appendChild(size);
        body.appendChild(row);
        fillSizes();
      })(i);
    }
    if (needed) {
      body.appendChild(priceRow);
      refresh();
    }

    var error = el('p', 'bop__error');
    error.hidden = true;
    var yes = el('button', 'bop__yes', options.yesLabel || (needed === 2 ? TEXT.yesTwo : TEXT.yesOne));
    yes.type = 'button';
    yes.addEventListener('click', async function () {
      if (!needed) return options.onYes && options.onYes();
      yes.disabled = true;
      error.hidden = true;
      var picks = rows.map(function (r) {
        return { variantId: Number(r.variant().id), productId: Number(r.model.value) };
      });
      try {
        await options.onAccept(picks);
      } catch (e) {
        yes.disabled = false;
        error.textContent = TEXT.error;
        error.hidden = false;
      }
    });
    body.appendChild(yes);
    body.appendChild(error);
    var skip = el('button', 'bop__skip', options.skipLabel || (needed === 2 ? TEXT.skipOnly : TEXT.skipOne));
    skip.type = 'button';
    skip.addEventListener('click', function () {
      closeDialog();
      if (options.onSkip) options.onSkip();
    });
    body.appendChild(skip);

    document.body.appendChild(dialog);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });
    dialog.showModal();
    yes.focus();
  }

  window.BangaOffer = { open: open, close: closeDialog };

  function codForm() {
    var form = document.querySelector('lx-cod');
    return form && form.data && form.data.catalog ? form : null;
  }

  /* 1. Landing: once per visit, not on the cart or order pages, not when the cart already has hoodies */
  function landing() {
    var seen = false;
    try {
      seen = sessionStorage.getItem(SEEN_KEY) === '1';
      sessionStorage.setItem(SEEN_KEY, '1');
    } catch (e) {}
    if (seen || data.cartCount > 0 || data.template === 'cart' || data.handle === 'order') return;
    setTimeout(function () {
      if (document.querySelector('dialog[open]') || document.querySelector('cart-drawer.active')) return;
      var form = codForm();
      if (form && form.takeOffer) {
        open({
          needed: 2,
          basePrices: [form.variantPrice(form.pieces[0])],
          defaultProductId: form.data.product.id,
          onAccept: function (picks) {
            closeDialog();
            form.takeOffer(picks);
            form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          },
        });
      } else {
        open({
          needed: 0,
          yesLabel: TEXT.browse,
          skipLabel: TEXT.later,
          onYes: function () {
            location.href = data.collection;
          },
        });
      }
    }, 1200);
  }

  /* 2. After add to cart: offer what is still missing for the next free hoodie */
  async function afterAdd() {
    var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
    var left = cart.item_count % 3;
    if (!left) return;
    var prices = [];
    cart.items.forEach(function (item) {
      for (var i = 0; i < item.quantity; i++) prices.push(item.original_price);
    });
    open({
      needed: 3 - left,
      basePrices: prices,
      defaultProductId: cart.items[0] && cart.items[0].product_id,
      onAccept: async function (picks) {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: picks.map(function (p) { return { id: p.variantId, quantity: 1 }; }) }),
        });
        if (!res.ok) throw new Error('add failed');
        location.href = data.orderPage;
      },
    });
  }

  function start() {
    landing();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'product-form') setTimeout(afterAdd, 500);
      });
    }
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
